/* eslint-disable import/no-anonymous-default-export */
export default (pay = [], action) => {
  switch (action.type) {
    case "GET ALL UNPAID CLAIMS":
      return action.payload;
    case "PAY CLAIM":
      return pay.filter((pay) => pay._id !== action.payload);
    default:
      return pay;
  }
};
